module.exports = __webpack_public_path__ + "img/Endpunkt.d90919cc.svg";